"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateOnBlurDirective = void 0;
const forms_1 = require("@angular/forms");
class ValidateOnBlurDirective {
    constructor(formControl) {
        this.formControl = formControl;
    }
    onBlur(event) {
        this.formControl.control.markAsTouched({ onlySelf: false });
    }
    onFocus(event) {
        this.formControl.control.markAsUntouched({ onlySelf: true });
    }
}
exports.ValidateOnBlurDirective = ValidateOnBlurDirective;
//# sourceMappingURL=onblur.validator.js.map